import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { FloatMessageProvider } from './components/Providers/FloatMessage'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <FloatMessageProvider>
      <App />
    </FloatMessageProvider>
  </React.StrictMode>
)


// Desregistro y purga definitiva de Service Workers y cachés locales
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  }).catch(() => {});
}

if ('caches' in window) {
  caches.keys().then((names) => {
    for (const name of names) {
      caches.delete(name);
    }
  }).catch(() => {});
}